import { useState, createContext, useEffect, useContext } from 'react'
import CityContext from "../contexts/CityContext"

export const CompareContext = createContext<any>(null)

const CompareProvider = ({ children }: any) => {

    const { city } = useContext(CityContext);

    const [compare, setCompare] = useState<string>('')
    useEffect(() => {
    }, [city, compare])

    return (
        <CompareContext.Provider value={{ compare, setCompare }}>
            {children}
        </CompareContext.Provider>
    )
}

export default CompareProvider